import { FC } from 'react'
import s from './OwnerSurveyPicnic.module.sass'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { Title } from '@shared/ui/Typography/Title'
import { Button } from '@shared/ui/Actions/Button'
import { Text } from '@shared/ui/Typography/Text'
import Link from '@shared/ui/Navigation/Link'
import ImageDesktop from '@images/ownerSurveyPicnic/desktop.webp'
import ImageMobile from '@images/ownerSurveyPicnic/mobile.webp'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'

interface Props {
  className?: string
}

const OwnerSurveyPicnic: FC<Props> = ({ className = '' }) => {
  const { isMobile } = useClientResponsive()

  return (
    <BlockBoundary>
      <section className={`${s.block} ${className}`}>
        <div className={s.content}>
          <Title sizes={'h2 h3'} className={s.title}>
            Станьте участником
            <br />
            Пикника Афиши
          </Title>
          <Text sizes={'M'} className={s.description}>
            Подайте заявку и попадите в шорт-лист на участие в фудкорте фестиваля в 2026 году
          </Text>
        </div>

        <div className={s.actions}>
          <Link
            href={'https://docs.google.com/forms/d/1Dofb61xgRuGMaf2wemg1HK5R7UD_Cm6AiDI4GW2r1ho/edit'}
            target={'_blank'}>
            <Button className={s.button} sizes={'XL L'} mode={'black'}>
              Стать участником
            </Button>
          </Link>

          <Link href={'https://www.afisha.ru/rests/documents/foodcourt_pic_26t.pdf'} target={'_blank'}>
            <Button className={s.button} sizes={'XL L'} mode={'white'}>
              Подробнее
            </Button>
          </Link>
        </div>

        <div
          className={s.background}
          style={{ backgroundImage: `url(${isMobile ? ImageMobile.src : ImageDesktop.src})` }}></div>
      </section>
    </BlockBoundary>
  )
}

export default OwnerSurveyPicnic
